// TODO: Migrate all folks importing from this file to point at CDO instead

export * from 'customer-data-objects/externalOptions/ExternalOptionsReferenceTypes';
export {};